import React, { useMemo } from "react";
import DashboardSelect from "./DashboardSelect";

export interface PropertyIdFilterOption {
  propertyId: number;
  label: string;
}

interface PropertyIdFilterProps {
  properties: PropertyIdFilterOption[];
  selectedPropertyId: number | null;
  onSelectProperty: (propertyId: number | null) => void;
  label?: string;
}

export default function PropertyIdFilter({
  properties,
  selectedPropertyId,
  onSelectProperty,
  label = "Imóvel",
}: PropertyIdFilterProps) {
  const options = useMemo(
    () => [
      { value: "all", label: "Todos os imóveis" },
      ...properties.map((property) => ({
        value: String(property.propertyId),
        label: property.label,
      })),
    ],
    [properties]
  );

  if (properties.length === 0) {
    return null;
  }

  return (
    <div className="w-full sm:min-w-[200px]">
      <DashboardSelect
        label={label}
        value={selectedPropertyId == null ? "all" : String(selectedPropertyId)}
        options={options}
        onChange={(value) => onSelectProperty(value === "all" ? null : Number(value))}
      />
    </div>
  );
}
